import { observer } from 'mobx-react-lite'
import { TextField } from 'shared/ui/TextField'
import { Typography, SectionCollapse, HelperText, EnumHelperText } from 'shared/ui'
import type { NpsQuestionStore } from './store/npsQuestionStore'

import styles from './styles.module.scss'

type INpsQuestionProps = {
  store: NpsQuestionStore
}

export const NpsQuestion = observer(({ store }: INpsQuestionProps) => (
  <SectionCollapse icon='messageQuestion' title='NPS question' error={store.error}>
    <div className={styles.container}>
      <Typography variant='text-input-label-small' ariaLabel='productNameLabel' color='tertiary'>
        Company or product name
      </Typography>
      <TextField
        variant='stroke'
        size='medium'
        value={store.companyName}
        onChange={store.setCompanyName}
        error={store.error}
        ariaLabel='companyName'
        InputProps={{ placeholder: 'Enter company or product name' }}
      />
      {store.error && (
        <HelperText icon={'alertTriangleSmall'} variant={EnumHelperText.Error} text={store.error} />
      )}
    </div>
  </SectionCollapse>
))
